import { createGlobalStyle } from 'styled-components';

import InterFont from '@assets/fonts/Inter-VariableFont.ttf';
import { THEME_MODULE } from '@themes/themeContext';

import InsightsStyle from '@insights_module/styles/InsightsStyles';
import AuthStyle from '@auth_module/styles/AuthStyles';
import AccountStyle from '@account_module/styles/AccountStyles';

const CustomStyles = createGlobalStyle({
  '@font-face': {
    fontFamily: 'Inter',
    src: `url(${InterFont})`,
    fontWeight: '100 1000',
  },
  body: {
    fontFamily: 'Inter, sans-serif',
  },
});

function getModuleStyles(module: string | null) {
  switch (module) {
    case THEME_MODULE.AUTH:
      return <AuthStyle />;
    case THEME_MODULE.INSIGHTS:
      return <InsightsStyle />;
    case THEME_MODULE.ACCOUNT:
      return <AccountStyle />;
  }
}

// We deliberately avoid using twin.macro global styles because it causes problems with the styles order of precedence.
// In the current composition of global styles twin.macro always takes precedence and requires overwriting with the
//  "!important" rule in a bunch of places.

const GlobalStyles = ({ module }: { module: string | null }) => {
  return (
    <>
      <CustomStyles />
      {module && getModuleStyles(module)}
    </>
  );
};

export default GlobalStyles;
